/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_Embed_Error_CancelledInputs */



/**
* | output |
* | --- |
* | "Cancelled." |
*
* @param {Cc_Embed_Error_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_cancelled = /** @type {((inputs?: Cc_Embed_Error_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annulé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgesagt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャンセル。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रद्द कर दिया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelado.")
	return /** @type {LocalizedString} */ ("Cancelled.")
});